import { GET_A2P_COMPLIANCE_STATUS } from '../actions/types';

export default function a2pComplianceReducer(state = null, action) {
	switch (action.type) {
		case GET_A2P_COMPLIANCE_STATUS:
			return action.payload || {};
		default:
			return state;
	}
}
